var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{ref:"queryTable"},[_c('v-card-title',[_c('v-icon',{attrs:{"color":_vm.toolbarColor}},[_vm._v("mdi-database")]),_vm._v(" Data")],1),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.rows,"items-per-page":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }